// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { message } from 'antd';
import { useNavigate } from "react-router-dom";

import { createProduct, setProductsForUpdate, refreshTableProducts, selectIsUpdateProduct, selectProductForUpdate, selectProductRefreshTable, setIsProductsForUpdate, updateProduct } from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import { IProducts } from "../../../redux/@types";
import { validateCreateProducts, validateUpdateProducts } from "../../../helpers";

interface PropsArray {
  [k: string]: number;
}

const helperObjQueryKey = {
  total_without_categories:         null,
  total_without_images:             'images',
  total:                            null,
  total_active:                     'status',
  total_inactive:                   'status',
  total_with_out_description_short: 'description_short',
  total_with_out_weight:            'weight',
  total_with_out_height:            'height',
  total_with_out_width:             'width',
  total_with_out_long:              'long',
}

const helperObjQueryVal = {
  total_without_categories:         `$or:[{category_id: 'null'},{category_id : 1}]`,
  total_without_images:             'false',
  total:                            null,
  total_active:                     'active',
  total_inactive:                   'inactive',
  total_with_out_description_short: 'null',
  total_with_out_weight:            'null',
  total_with_out_height:            'null',
  total_with_out_width:             'null',
  total_with_out_long:              'null',
}

export const useProducts = () => {
  const [querySelectorTransform, setQuerySelectorTransform] = useState< PropsArray>({})
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isUpdateProduct = useSelector(
    selectIsUpdateProduct
  );
  const dataUpdateProduct = useSelector(
    selectProductForUpdate
  );
  const isRefreshTableProducts = useSelector(
    selectProductRefreshTable
  );

  const [isLoading, setIsLoading] = useState(false);
  const [tableProps, setTableProps] = useState<TableProperties>();

  const navigateProductsCreate = () => {
    dispatch(setIsProductsForUpdate(false));
    navigate(`/products/new`);
  };

  const formMethodsCreate = useForm<IProducts>({
    resolver: yupResolver(validateCreateProducts),
    defaultValues: {
      is_fresh: 'false',
    },
  });

  const formMethodsUpdate = useForm<IProducts>({
    resolver: yupResolver(validateUpdateProducts),
  });

useEffect(() => {
    if (isUpdateProduct && dataUpdateProduct) {
      formMethodsCreate.reset();
      formMethodsUpdate.reset({
        ...dataUpdateProduct,
        approximate_grams:
          dataUpdateProduct.approximate_grams != null
            ? Number(dataUpdateProduct.approximate_grams)
            : dataUpdateProduct.quantity_per_unit_measure != null
              ? Number(dataUpdateProduct.quantity_per_unit_measure)
              : null,
        is_fresh: dataUpdateProduct.is_fresh ?? 'false',
      });
    }

    return () => {
      formMethodsUpdate.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateProduct, dataUpdateProduct]);

  const updateStatus = async(value: "active" | "inactive", id: any) =>{
    if (isLoading) return;
    setIsLoading(true);
    await updateProduct({
      id,
      status: value,
    })
    .then((res: Partial<IProducts>) => {
      setIsLoading(false);
      if (res.id) {
        // dispatch(bannersChangeModalState());
        message.success(
          `Se ha actualizado con éxito el estado del producto con id:${res.id}`
        );
        dispatch(refreshTableProducts(true));
      } else {
        message.error(res as string);
      }
    })
    .catch((err: any) => {
      setIsLoading(false);
      console.log(err);
      message.error(err.message);
    });
  }

const onSubmitCreateOrUpdate = async (data: IProducts) => {
    // console.log({ data });
    if (isLoading) return;
    setIsLoading(true);
    if (isUpdateProduct) {
    // console.log("Actualiando===>", data);
      await updateProduct({
        id:data.id,
        name:data.name,
        code: data.code,
        category_id: data.category_id,
        category_id_2: data.category_id_2 || undefined,
        category_id_3: data.category_id_3 || undefined,
        brand_id: Number(data.brand_id),
        price: data.price,
        tax_rule_id: Number(data.tax_rule_id),
        discount_price: data.discount_price,
        price_with_tax: data.price_with_tax,
        // discount_price_whit_tax: data.discount_price_whit_tax,
        quantity: data.quantity,
        unit_measure: data.unit_measure,
        quantity_per_unit_measure:
          data.approximate_grams != null && data.approximate_grams !== ''
            ? Number(data.approximate_grams)
            : data.quantity_per_unit_measure,
        approximate_grams:
          data.approximate_grams != null && data.approximate_grams !== ''
            ? Number(data.approximate_grams)
            : null,
        is_fresh: data.is_fresh ? data.is_fresh.toString() : 'false',
        weight: data.weight,
        heigh: data.heigh,
        width: data.width,
        long: data.long,
        ...(data.description  ? {description: data.description === "<p><br></p>" ? "" :data.description} : {}),
        status: data.status,
        position_more_sales: data.position_more_sales,
        // user_guide_composition: data.user_guide_composition,
        // user_guide_care: data.user_guide_care,
        premium: data.premium.toString(),
        ...(data.type_of_cut_image_path  ? {type_of_cut_image_path: data.type_of_cut_image_path,} : {}),
        ...(data.preparation_tutorial_video_path  ? {preparation_tutorial_video_path: data.preparation_tutorial_video_path,} : {}),
        ...(data.recommendations_image_cover_path  ? {recommendations_image_cover_path: data.recommendations_image_cover_path,} : {}),
        ...(data.recommendations_text_html  ? {recommendations_text_html: data.recommendations_text_html,} : {}),
        // type_of_cut_image_path: data.type_of_cut_image_path,
        // preparation_tutorial_video_path: data.preparation_tutorial_video_path,
        // recommendations_image_cover_path: data.recommendations_image_cover_path,
        // recommendations_text_html: data.recommendations_text_html,
      })
        .then((res: Partial<IProducts>) => {
          setIsLoading(false);
          // dispatch(mappingUpdatedUser(res))
          if (res.id) {
            //navigate(`/products`)
            message.success(
              `Se ha actualizado con éxito el producto con id:${res.id}`
            );
            dispatch(setProductsForUpdate(res as any))
            dispatch(refreshTableProducts(true));
          } else {
            message.error(res as string);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          console.log(err);
          message.error(err.message);
        });
    } else {
      // console.log('Creando===>',data)
      // setIsLoading(false);
      await createProduct({
        name:data.name,
        code: data.code,
        category_id: Number(data.category_id),
        ...(data.category_id_2  ? {category_id_2:  Number(data.category_id_2 )} : {}),
        ...(data.category_id_3  ? {category_id_3:  Number(data.category_id_3 )} : {}),
        brand_id: Number(data.brand_id),
        price: data.price,
        tax_rule_id: Number(data.tax_rule_id),
        discount_price: data.discount_price,
        price_with_tax: data.price_with_tax,
        discount_price_whit_tax: data.discount_price_whit_tax,
        quantity: data.quantity,
        unit_measure: data.unit_measure,
        quantity_per_unit_measure:
          data.approximate_grams != null && data.approximate_grams !== ''
            ? Number(data.approximate_grams)
            : data.quantity_per_unit_measure,
        approximate_grams:
          data.approximate_grams != null && data.approximate_grams !== ''
            ? Number(data.approximate_grams)
            : null,
        is_fresh: data.is_fresh ? data.is_fresh.toString() : 'false',
        weight: data.weight,
        heigh: data.heigh,
        width: data.width,
        long: data.long,
        description: data.description,
        status: data.status,
        position_more_sales: data.position_more_sales,
        // user_guide_composition: data.user_guide_composition,
        // user_guide_care: data.user_guide_care,
        premium: data.premium ? data.premium.toString() : "false",
        ...(data.type_of_cut_image_path  ? {type_of_cut_image_path: data.type_of_cut_image_path,} : {}),
        ...(data.preparation_tutorial_video_path  ? {preparation_tutorial_video_path: data.preparation_tutorial_video_path,} : {}),
        ...(data.recommendations_image_cover_path  ? {recommendations_image_cover_path: data.recommendations_image_cover_path,} : {}),
        ...(data.recommendations_text_html  ? {recommendations_text_html: data.recommendations_text_html,} : {}),
      })
        .then((res: any) => {
          setIsLoading(false);
          if (res.id) {
            // dispatch(productsChangeModalState());
            navigate(`/products`)
            window.scrollTo(0, 0)
            message.success(
              `Se ha creado con éxito el producto con id:${res.id}`
            );
            dispatch(refreshTableProducts(true));
          } else {
            message.error(res as any);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          console.log(err);
          message.error(err.message);
        });
    }
  };

  useEffect(() => {
    if (isRefreshTableProducts) {
      tableProps?.refresh();
      dispatch(refreshTableProducts(false));
    }
 // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isRefreshTableProducts]);

const handleQueryTransform = ( val: [] | string[])=>{
  if(val.length === 0){
    return setQuerySelectorTransform({})
  }
  else{
    const objAux: PropsArray= {}
    val.forEach((item)=>{
      if(helperObjQueryKey.hasOwnProperty(item) && item === 'total_without_categories'){
        return objAux['$or'] = [{category_id: 'null'},{category_id : 1}]
      } else if (helperObjQueryKey.hasOwnProperty(item)) {
        return objAux[helperObjQueryKey[item as keyof typeof helperObjQueryKey]] = helperObjQueryVal[item as keyof typeof helperObjQueryVal]
      }
    })
    return setQuerySelectorTransform(objAux)
  }
}

  return {
    //state
    querySelectorTransform,
    dataUpdateProduct,
    isUpdateProduct,
    isLoading,
    tableProps,
    //methods
    formMethodsCreate,
    formMethodsUpdate,
    setTableProps,
    //functions
    navigateProductsCreate,
    onSubmitCreateOrUpdate,
    updateStatus,
    handleQueryTransform
  }
}
